export default "/static/media/icon-twitter.856a4a64.svg";